/** Romanian-locale date/time formatting helpers, built on Intl (no deps). */

const dateFmt = new Intl.DateTimeFormat('ro-RO', {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
});

const dateTimeFmt = new Intl.DateTimeFormat('ro-RO', {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const timeFmt = new Intl.DateTimeFormat('ro-RO', {
  hour: '2-digit',
  minute: '2-digit',
});

export function formatDate(value: Date | null | undefined): string {
  return value ? dateFmt.format(value) : '—';
}

export function formatDateTime(value: Date | null | undefined): string {
  return value ? dateTimeFmt.format(value) : '—';
}

export function formatTime(value: Date | null | undefined): string {
  return value ? timeFmt.format(value) : '—';
}

/** "1h 30min" / "45min" duration between two instants. */
export function formatDuration(start: Date, end: Date): string {
  const minutes = Math.max(0, Math.round((end.getTime() - start.getTime()) / 60_000));
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h && m) return `${h}h ${m}min`;
  if (h) return `${h}h`;
  return `${m}min`;
}
